export { default } from "ember-click-outside/modifiers/on-click-outside";
